import React, { useEffect } from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import { useHeaderContext } from "@/context/header/useHeaderContext";
import { type MediaManagerScreenState } from "@/schemas/screen/configs";
import { MediaManagerTabs, Screen } from "@/schemas/screen/tabs";
import MediaManagerScreen from "@/screens/MediaManager/MediaManagerScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  const { setCurrentScreen } = useHeaderContext();

  useEffect(() => {
    const newMediaTabScreen: MediaManagerScreenState = {
      screenId: Screen.MEDIA_MANAGER,
      activeTabId: MediaManagerTabs.PUBLIC,
      filters: null,
    };
    setCurrentScreen(newMediaTabScreen);
  }, []);

  return <MediaManagerScreen {...props} />;
}

export default withSessionHandling(Page);
